import { ReactNode, useCallback, useMemo, useState } from 'react';

import { TutorialContext } from '@/context';
import { TutorialContextValue, TutorialMappingTab } from '@/types';

export const TutorialProvider = ({ children }: { children: ReactNode }) => {
  const [isActive, setIsActive] = useState(false);
  const [moreActionsTab, setMoreActionsTab] = useState<TutorialMappingTab | null>(null);
  const [bulkSelectTab, setBulkSelectTab] = useState<TutorialMappingTab | null>(null);
  const [hasSeenTutorial, setHasSeenTutorial] = useState(false);

  const startTutorial = useCallback(() => {
    setMoreActionsTab(null);
    setBulkSelectTab(null);
    setIsActive(true);
  }, []);

  const stopTutorial = useCallback(() => {
    setIsActive(false);
    setMoreActionsTab(null);
    setBulkSelectTab(null);
  }, []);

  const markAsSeen = useCallback(() => {
    setHasSeenTutorial(true);
  }, []);

  const value = useMemo<TutorialContextValue>(
    () => ({
      isActive,
      hasSeenTutorial,
      moreActionsTab,
      bulkSelectTab,
      startTutorial,
      stopTutorial,
      markAsSeen,
      setMoreActionsTab,
      setBulkSelectTab,
    }),
    [isActive, hasSeenTutorial, moreActionsTab, bulkSelectTab, startTutorial, stopTutorial, markAsSeen],
  );

  return <TutorialContext.Provider value={value}>{children}</TutorialContext.Provider>;
};
